export interface Application {
    id: string;
    name: string;
    description?: string;
    base_url?: string;
    docs_url?: string;
    logo_url?: string;
    callback_url?: string;
    status?: number; // 1=active, 0=inactive, 3=beta
    is_public?: boolean;
    is_enabled?: boolean;
    platforms?: string[];
    owner_ids?: string[];
    created_at?: string;
    updated_at?: string;
}

export type ApplicationStatus = 'active' | 'inactive' | 'beta' | 'unknown';

export function getApplicationStatusLabel(status?: number): ApplicationStatus {
    switch (status) {
        case 1: return 'active';
        case 2: return 'inactive';
        case 3: return 'beta';
        default: return 'unknown';
    }
}
